export const styles = {
  siteVisitTitle: {
    background: '#018544',
  },
  createIcon: {
    color: 'light',
    cursor: 'pointer',
  },
};
